import React, { PureComponent } from 'react';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { emit } from 'helpers/global-events';
import Form, {
  Input,
  Text,
  ImageInput,
  InputListBox,
  InputLabel
} from 'containers/form';
import Row, { Col } from 'components/row';
import ScrollComponent from 'components/scroll-component';
import LayoutContainer, { Stretch, Fixed } from 'components/layout-container';
import Hint from 'components/hint';
import Button, { btnThemes } from 'components/button';

const classesBemForm = new Bem('modalContentAdmin');

// User form for create new club.
export default class ClubUserAddForm extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    clubId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    closeModal: PropTypes.func,
    parent: PropTypes.number,
    router: routerShape
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.onSubmitForm = this.onSubmitForm.bind(this);
  }

  // After submit form make redirect into new club.
  onSubmitForm(val = {}) {
    if (!this.props.clubId) {
      // TODO: change this to our link builder
      const forumUrlTitle = 'new-club';
      const id = val.id;
      const url = `/clubs/${forumUrlTitle}-c${id}`;

      return this.props.router.push(url);
    }

    emit('updateClubList');
  }

  render() {
    const { className, id, parent, clubId } = this.props;
    const otherProps = {};

    if (!id) {
      otherProps.defaultValues = {
        parent,
      };
    }

    return (
      <ScrollComponent {...classesBemForm({ extra: className })}>
        <Form
          {...classesBemForm('flexColumn')}
          updateEvent="updateClubList"
          controller="club/club-form"
          entityId={clubId}
          onSubmit={this.onSubmitForm}
          showPopupValidationMessages
          hFull
          {...otherProps}
        >
          <LayoutContainer>
            <Stretch>
              <Row>
                <Col allPr={0}>
                  <Input dataBind="forum_title" />
                </Col>
              </Row>
              <Row>
                <Col allPr={0}>
                  <Text dataBind="forum_description" />
                </Col>
              </Row>
              <Row>
                <Col allPr={20} md={4} mt={4}>
                  <InputLabel dataBind="forum_addition.club_image" />
                  <Hint text="Вы можете загружать картинки в форматах: jpeg, jpg, png, gif, tiff" />
                </Col>
                <Col allPr={0} md={8} mt={8}>
                  <ImageInput
                    dataBind="forum_addition.club_image"
                    imageSize={false}
                    dataView="ava"
                    circled
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputListBox
                    dataBind="forum_addition.club_type"
                    hasLabel
                    horizontal
                    nullValueItem={false}
                  />
                </Col>
              </Row>
            </Stretch>
            <Fixed {...classesBemForm('footer')}>
              <Row allAuto allJustifyCFlexEnd {...classesBemForm('btnsContainer')}>
                <Col allPr={0}>
                  <Button
                    data-delete
                    label="Удалить"
                    theme={btnThemes.light}
                    big
                  />
                </Col>
                <Col allPr={0} allPl={20}>
                  <Button
                    data-submit
                    label="Опубликовать"
                    theme={btnThemes.sky}
                    big
                  />
                </Col>
              </Row>
            </Fixed>
          </LayoutContainer>
        </Form>
      </ScrollComponent>
    );
  }
}
